/* eslint-disable @angular-eslint/directive-selector */
import { Directive, OnInit, TemplateRef } from "@angular/core";
import { NavigationMenuService } from "../../services/navigation-menu/navigation-menu.service";
import { Observable } from "rxjs";

export interface CallToActionLabel {
  label: string | Observable<string>;
  icon: string;
}

@Directive({
  selector: "[callToAction]",
  standalone: true
})
export class CtaDirective implements OnInit {
  constructor(
    private navigationMenu: NavigationMenuService,
    private template: TemplateRef<any>
  ) {}

  ngOnInit(): void {
    this.navigationMenu.cta.next(this.template);
  }
}
